import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Card,
  Col,
  Form,
  Row,
  Container,
  ProgressBar,
  Accordion,
} from "react-bootstrap";
import { Chart } from "react-google-charts";
import Nav from "./Navbar";
import Footer from "./Footer";
import loaderGif from "../Images/loader.gif";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import key1 from "../Images/key1.svg";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import pay from "../Images/pay.png";
import { GlobalContext } from "../Context/GlobalState";
import TestimonialPage from "./Testonomialraghar";
import tool9 from "../Images/bixanalyzer.png";
import SideTab from "./Toolstab";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { basicauth } from "../Utils/Credentials";
import { Helmet } from "react-helmet";
import Smotooltab from "./Smotooltab";
const FacebookPostContentCreator = () => {
  const { siteurl } = useContext(GlobalContext);

  const domainTypeOptions = [
    { value: "domain", label: "Domain" },
    { value: "subdomain", label: "Subdomain" },
  ];

  const regionOptions = [
    { value: "en-US", label: "United States (en-US)" },
    { value: "en-GB", label: "United Kingdom (en-GB)" },
    { value: "en-CA", label: "Canada (English) (en-CA)" },
    { value: "en-AU", label: "Australia (en-AU)" },
  ];

  const [formData, setFormData] = useState({
    domainInput: siteurl,
    domainType: domainTypeOptions[0],
    region: regionOptions[0],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const [rankingKeywords, setRankingKeywords] = useState([]);
  const [queary, setqueary] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  const DomainRankingKeywords = async (type) => {
    try {
      const uuid = generateUUID();
      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/DomainRankingKeywords`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            uuid: uuid,
            url: formData.domainInput,
            scope: formData.domainType?.value,
            locale: formData.region?.value,
            type: type,
          }),
        }
      );
      const data = await res.json();

      if (data.status === "0" && data.data) {
        const rankingData = data.data.map((item) => ({
          keyword: item.keyword,
          url: item.url,
          ranking_page: item.ranking_page,
          rank_position: item.rank_position,
          difficulty: item.difficulty,
          volume: item.volume,
        }));

        setRankingKeywords(rankingData);
        setqueary({ query: data.data[0].url });
        processChartData(rankingData);
        setShowResults(true);
      } else {
        setShowResults(false);
      }
    } catch (error) {
      console.log("error", error);
      setShowResults(false);
    }
  };

  const processChartData = (keywords) => {
    const ranges = {
      "1-3": 0,
      "4-10": 0,
      "11-20": 0,
      "21-30": 0,
      "31-40": 0,
      "41-50": 0,
    };
    keywords.forEach((keyword) => {
      const position = keyword.rank_position;
      if (position >= 1 && position <= 3) ranges["1-3"]++;
      else if (position >= 4 && position <= 10) ranges["4-10"]++;
      else if (position >= 11 && position <= 20) ranges["11-20"]++;
      else if (position >= 21 && position <= 30) ranges["21-30"]++;
      else if (position >= 31 && position <= 40) ranges["31-40"]++;
      else if (position >= 41 && position <= 50) ranges["41-50"]++;
    });

    setChartData([
      { range: "#1-3", count: ranges["1-3"] },
      { range: "#4-10", count: ranges["4-10"] },
      { range: "#11-20", count: ranges["11-20"] },
      { range: "#21-30", count: ranges["21-30"] },
      { range: "#31-40", count: ranges["31-40"] },
      { range: "#41-50", count: ranges["41-50"] },
    ]);
  };

  const countKeywordsInRankRange = (keywords, start, end) => {
    return keywords.filter(
      (keyword) =>
        keyword.rank_position >= start && keyword.rank_position <= end
    ).length;
  };

  const range1to3 = countKeywordsInRankRange(rankingKeywords, 1, 3);
  const range4to10 = countKeywordsInRankRange(rankingKeywords, 4, 10);
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Bix Keyword Analyzer – Best Tool for Keyword Insights 2025",
    url: "https://seobix.com/bix-keyword-analyzer",
    description:
      "Discover powerful keyword insights with Bix Keyword Analyzer – the best tool for SEO in 2025. Find top-ranking keywords, analyze competition, and boost your website traffic effortlessly.",
    applicationCategory: "SEO Tool",
    operatingSystem: "Web",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
      category: "Free SEO Tool",
    },
    publisher: {
      "@type": "Organization",
      name: "SeoBix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
        width: 600,
        height: 60,
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Bix Keyword Analyzer",
          item: "https://seobix.com/bix-keyword-analyzer",
        },
      ],
    },
    inLanguage: "en",
    keywords: [
      "Bix Keyword Analyzer",
      "SeoBix keyword tool",
      "Keyword insights 2025",
      "Best keyword analyzer tool",
      "Keyword research tool 2025",
    ],
  };

  return (
    <>
      <div className="p-0 m-1" style={{ overflow: "clip" }}>
        <Helmet>
          <title>
            Bix Keyword Analyzer – Best Tool for Keyword Insights 2025
          </title>
          <meta
            name="description"
            content="Discover powerful keyword insights with Bix Keyword Analyzer – the best tool for SEO in 2025. Find top-ranking keywords, analyze competition, and boost your website traffic effortlessly."
          />
          <link
            rel="canonical"
            href="https://seobix.com/bix-keyword-analyzer"
          />

          <meta property="og:type" content="website" />
          <meta
            property="og:url"
            content="https://seobix.com/bix-keyword-analyzer"
          />
          <meta
            property="og:title"
            content="Bix Keyword Analyzer – Best Tool for Keyword Insights 2025"
          />
          <meta
            property="og:description"
            content="Discover powerful keyword insights with Bix Keyword Analyzer – the best tool for SEO in 2025. Find top-ranking keywords, analyze competition, and boost your website traffic effortlessly."
          />
          <meta
            property="og:image"
            content="https://seobix.com/Images/Backlinks.png"
          />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:url"
            content="https://seobix.com/bix-keyword-analyzer"
          />
          <meta
            name="twitter:title"
            content="Bix Keyword Analyzer – Best Tool for Keyword Insights 2025"
          />
          <meta
            name="twitter:description"
            content="Discover powerful keyword insights with Bix Keyword Analyzer – the best tool for SEO in 2025. Find top-ranking keywords, analyze competition, and boost your website traffic effortlessly."
          />
          <meta
            name="twitter:image"
            content="https://seobix.com/Images/Backlinks.png"
          />

          <script type="application/ld+json">
            {JSON.stringify(jsonLdData)}
          </script>
        </Helmet>
        <div>
          <Nav />
        </div>
        <Row
          className="d-flex justify-content-center "
          style={{
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
          }}
        >
          <Col
            md={10}
            className="mt-4"
            style={{
              borderRadius: "1rem",
            }}
          >
            <div className="m-3">
              <style>
                {`
   .hide-scrollbar::-webkit-scrollbar {
   display: none; }
   `}
              </style>

              <h1
                style={{
                  fontSize: "4.5rem",
                  fontWeight: "500",
                  color: "#090040",
                }}
              >
               Post & Content Creator 
              </h1>
              <p
                style={{
                  fontSize: "1.2rem",
                  fontWeight: "400",
                  color: "#090040",
                }}
              >
                Try the free version of SEOBIX Keyword Analyzer. Get a glimpse
                <br />
                into how your website ranks for important keywords — in real
                time.
              </p>

              <Form className="mb-4">
                <Row className="pt-5 align-items-center rounded ">
                  <Col md={6}>
                    <Form.Control
                      type="text"
                      placeholder="Enter a domain, subdomain, or exact page"
                      value={formData.domainInput}
                      onChange={(e) =>
                        handleChange("domainInput", e.target.value)
                      }
                    />
                  </Col>

                  <Col md={4} className="d-flex align-items-center p-0">
                    <Form.Select
                      className="mx-2"
                      value={formData.domainType.value}
                      onChange={(e) =>
                        handleChange(
                          "domainType",
                          domainTypeOptions.find(
                            (opt) => opt.value === e.target.value
                          )
                        )
                      }
                    >
                      {domainTypeOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>

                    <Form.Select
                      value={formData.region.value}
                      onChange={(e) =>
                        handleChange(
                          "region",
                          regionOptions.find(
                            (opt) => opt.value === e.target.value
                          )
                        )
                      }
                    >
                      {regionOptions.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  <Col md={2} className="d-flex justify-content-center">
                    <Button
                      size="sm"
                      style={{ background: "#441752", color: "#fff" }}
                      onClick={() => DomainRankingKeywords("1")}
                    >
                      Analyze
                    </Button>
                  </Col>
                </Row>
              </Form>
              {showResults && (
                <>
                  {" "}
                  <Row className="p-0 m-2">
                    <Card
                      className="p-2 m-2 col"
                      style={{
                        background: "#E3F2FD",
                        border: "1px solid #90CAF9",
                      }}
                    >
                      <div className="row p-0 m-0">
                        <div className="col justify-content-center text-center">
                          <h6>Site</h6>
                          <hr className="m-1 p-0" />
                          <h5>{queary?.query}</h5>
                        </div>
                        <div className="col justify-content-center text-center">
                          <h6>Ranking Keyword</h6>
                          <hr className="m-1 p-0" />
                          <h4>{rankingKeywords?.length}</h4>
                        </div>
                      </div>
                    </Card>

                    <Card
                      className="p-2 m-2 col"
                      style={{
                        background: "#FFF3E0",
                        border: "1px solid #FFB74D",
                      }}
                    >
                      <div>
                        <h6>Top Position Keywords</h6>
                        <hr className="m-1 p-0" />
                        <Row className="m-0 p-0">
                          <Col>
                            <p className="mb-0"># 1-3</p>
                          </Col>
                          <Col>
                            <p className="mb-0">{range1to3} Keywords</p>
                          </Col>
                        </Row>
                        <Row className="m-0 p-0">
                          <Col>
                            <p className="mb-0"># 4-10</p>
                          </Col>
                          <Col>
                            <p className="mb-0">{range4to10} Keywords</p>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  </Row>
                  <div className="table-container m-3">
                    <table
                      className="table table-bordered w-100 mt-3"
                      style={{
                        backgroundColor: "#F3E5F5",
                        borderBottom: "2px solid #6A1B9A",
                        color: "#4A148C",
                      }}
                    >
                      <thead style={{ backgroundColor: "#CE93D8" }}>
                        <tr>
                          <th>Keyword</th>
                          <th>
                            Domain<h6>{queary?.query}</h6>
                          </th>
                          <th>Difficulty</th>
                          <th>Monthly Volume</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rankingKeywords
                          ?.slice(0, 5)
                          .map((keywordData, index) => (
                            <tr key={index}>
                              <td>{keywordData?.keyword}</td>
                              <td>
                                #{keywordData?.rank_position}
                                <br />
                                <p className="mb-0">
                                  {keywordData?.ranking_page}
                                </p>
                              </td>
                              <td>{keywordData?.difficulty}</td>
                              <td>{keywordData?.volume}</td>
                            </tr>
                          ))}

                        {rankingKeywords?.length > 5 && (
                          <tr style={{ filter: "blur(3px)", opacity: 0.5 }}>
                            <td colSpan="4" className="text-center">
                              More data hidden...
                            </td>
                          </tr>
                        )}

                        {rankingKeywords?.length > 5 && (
                          <tr>
                            <td colSpan="4" className="text-center">
                              <a
                                href="/register"
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  display: "inline-block",
                                  marginTop: "10px",
                                  padding: "8px 20px",
                                  backgroundColor: "#4F46E5",
                                  color: "#fff",
                                  textDecoration: "none",
                                  borderRadius: "8px",
                                }}
                              >
                                View Full Report
                              </a>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>{" "}
                </>
              )}
              <div
                style={{
                  // background: "#2E3C56",
                  margin: "2rem 0",
                  padding: "2rem 1rem",
                  color: "#fff",
                  borderTop: "1px solid #495670",
                  borderBottom: "1px solid #495670",
                }}
              >
                <Row>
                  <Col md={6}>
                    <h3
                      style={{
                        fontWeight: "600",
                        marginBottom: "1rem",
                        color: "#090040",
                        fontSize: "2.5rem",
                      }}
                    >
                      The most insightful keyword tracker
                    </h3>
                    <p style={{ fontSize: "1.2rem", color: "#090040" }}>
                      SeoBix's Keyword Analyzer &nbsp;
                      <span style={{ color: "#F80", fontWeight: "400" }}>
                        tracks rankings and reveals opportunities &nbsp;
                      </span>
                      with real-time data that helps you improve SEO and
                      outperform competitors.
                    </p>
                    <p
                      className="mb-4"
                      style={{ fontSize: "1.5rem", color: "#090040" }}
                    >
                      Start Your SEO Journey with SeoBix!
                    </p>
                    <div className="d-flex align-items-center gap-3 flex-wrap">
                      <a
                        href="/register"
                        className="start-now-btn"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        Sign Up
                      </a>
                    </div>
                  </Col>
                  <Col md={6}>
                    <Row>
                      <Col
                        xs={6}
                        style={{ textAlign: "center", marginBottom: "2rem" }}
                      >
                        <div
                          style={{
                            fontSize: "4rem",
                            fontWeight: "600",
                            color: "#090040",
                          }}
                        >
                          1M+
                        </div>
                        <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                          Pages in index
                        </div>
                      </Col>
                      <Col
                        xs={6}
                        style={{
                          textAlign: "center",
                          marginBottom: "2rem",
                          color: "#090040",
                        }}
                      >
                        <div style={{ fontSize: "4rem", fontWeight: "600" }}>
                          60K+
                        </div>
                        <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                          Internal backlinks
                        </div>
                      </Col>
                      <Col xs={6} style={{ textAlign: "center" }}>
                        <div
                          style={{
                            fontSize: "4rem",
                            fontWeight: "600",
                            color: "#090040",
                          }}
                        >
                          100+
                        </div>
                        <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                          Domains
                        </div>
                      </Col>
                      <Col xs={6} style={{ textAlign: "center" }}>
                        <div
                          style={{
                            fontSize: "4rem",
                            fontWeight: "600",
                            color: "#090040",
                          }}
                        >
                          200K+
                        </div>
                        <div style={{ fontSize: "1.2rem", color: "#090040" }}>
                          External backlinks
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center mt-5" style={{ margin: "0" }}>
          <Col md={10}>
            <Row className="justify-content-between">
              <Content />
              <Col md={3}>
                <div
                  className="mb-5"
                  style={{
                    position: "sticky",
                    top: "20px",
                    zIndex: 10,
                    background: "#f8f9fa",
                    padding: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <h5
                    className="text-center mb-4"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.3rem",
                      color: "#fff",
                      backgroundColor: "#799EFF",
                      display: "inline-block",
                      padding: "6px 16px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    🚀 Explore More SEO Tools
                  </h5>
                  <Smotooltab />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background:
              "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",

            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        >
          <Footer />
        </div>
      </div>
    </>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
    <Col md={8}>
      <h2> Create posts, images, and videos optimized for Facebook</h2>
      <p>
        And in the digital age of today, it is crucial for businesses and content creators alike to create great Facebook content. However, just posting updates isn’t going to cut it; your content needs to be interesting, visually attractive and optimized for ultimate reach and impact. Use the Facebook Post & Content Creator Tool to create posts, images and videos especially for Facebook - encourage engagement, visibility and audience action.
      </p>
      <p>
        This generator will help you quickly make sure that your panel answers are on point and every post you generate performs and appeals to market. Here, we explain how it works, its features and why you need to add it to your Facebook strategy.
      </p>
  
      <h2>Using Facebook Post & Content Creator Tool</h2>
      <div style={{ position: "relative" }}>
        <p
          style={{
            maxHeight: showMore ? "none" : "4.2rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 2,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            filter: showMore ? "none" : "blur(2px)",
            transition: "all 0.3s ease",
            marginBottom: showMore ? "1rem" : "2.5rem",
          }}
        >
          With our software, generating premium Facebook content is a piece of cake. Here’s how you can start:
          <br />
          <strong>Step 1: Choose Your Content Kind</strong> – Select if you wish to make a post, an image or a video. Complete format gives you a bunch of templates and guides to help you produce professional-looking content.
          <br />
          <strong>Step 2: Customize Your Content</strong> – Include branded text, images, videos and other assets to provide brand context. The instrument also offers optimisation hints, as optimal text length, image size and video duration for Facebook’s algorithms.
          <br />
          <strong>Step 3: Preview Your Content</strong> – View exactly how your post, image or video will appear on Facebook. Your content will always look great on desktop, mobile and various feed styles.
          <br />
          <strong>Step 4: Download or Schedule</strong> – When finished, you can download or schedule a Facebook post directly. This tool makes sure your content complies with all Facebook standards for expanded reach.
        </p>
  
        {!showMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0.5rem",
              left: 0,
              right: 0,
              height: "2.5em",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
            }}
          />
        )}
      </div>
  
      <div className="d-flex justify-content-center">
        {!showMore && (
          <Button
            onClick={() => setShowMore(true)}
            style={{
              padding: "6px 20px",
              backgroundColor: "#fff",
              color: "#0d6efd",
              fontWeight: "600",
              fontSize: "0.95rem",
              border: "2px solid #0d6efd",
              borderRadius: "999px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#0d6efd";
            }}
          >
            Read More
          </Button>
        )}
      </div>
  
      {showMore && (
        <>
          <h2>Facebook Post & Content Creator Tool Features</h2>
          <ul>
            <li>
              <strong>Post Templates and Designs:</strong> Select from a range of templates for posts, photos and videos crafted to drive awareness and engagement.
            </li>
            <li>
              <strong>Image Optimization:</strong> Perfect sizing, resolution, and aspect ratio for Facebook to make posts more accessible and engaging.
            </li>
            <li>
              <strong>Video Creation and Editing:</strong> Eye-catching videos with built-in editing tools. Include text, transitions, music, and branding elements for standout posts.
            </li>
            <li>
              <strong>Text Suggestions and Hashtag Optimization:</strong> Receive tips for compelling copy, suggested hashtags, and optimal text length.
            </li>
            <li>
              <strong>Preview Across Devices:</strong> Ensure your content looks great on mobile, tablet, and desktop.
            </li>
            <li>
              <strong>Scheduling and Posting:</strong> Schedule posts at the best times for engagement.
            </li>
          </ul>
  
          <h2>Advantages of using the Facebook Post & Content Creator tool</h2>
          <ul>
            <li><strong>Save Time and Effort:</strong> Templates, automation, and editing tools make content creation fast and efficient.</li>
            <li><strong>Boost Engagement:</strong> Optimized posts get more likes, comments, and shares without paid promotion.</li>
            <li><strong>Maintain Brand Consistency:</strong> Use logos, colors, and fonts consistently across all posts.</li>
            <li><strong>Improve Visibility:</strong> Optimized images, videos, and hashtags help rank higher in Facebook feeds.</li>
            <li><strong>Data-Driven Content Creation:</strong> Use insights from previous posts to guide new content creation.</li>
            <li><strong>Simplified Strategy Management:</strong> Schedule posts, track content performance, and manage strategy efficiently.</li>
          </ul>
  
          <h2>How the Facebook Post & Content Creator Tool Works</h2>
          <ul>
            <li>Choose your content type: post, image, or video.</li>
            <li>Personalize with templates, graphics, text, and videos.</li>
            <li>Preview content on all devices.</li>
            <li>Use hashtags, captions, and recommended dimensions.</li>
            <li>Download or schedule posts for optimal reach and engagement.</li>
          </ul>
  
          <h3>Frequently Asked Questions (FAQs)</h3>
          <Accordion defaultActiveKey="0" className="mb-5" flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>What is the Facebook Post & Content Creator Kit?</Accordion.Header>
              <Accordion.Body>
                It’s a service that guides users on the types of posts, images and videos they should post to Facebook, with templates, editing tools and scheduling.
              </Accordion.Body>
            </Accordion.Item>
  
            <Accordion.Item eventKey="1">
              <Accordion.Header>Can I use the tool for free?</Accordion.Header>
              <Accordion.Body>
                Yes; free templates as well as basic editing. Advanced editing, scheduling, and analytics are available via premium options.
              </Accordion.Body>
            </Accordion.Item>
  
            <Accordion.Item eventKey="2">
              <Accordion.Header>Who will find it useful?</Accordion.Header>
              <Accordion.Body>
                Social media managers, influencers, content creators, companies, and agencies working on behalf of multiple pages.
              </Accordion.Body>
            </Accordion.Item>
  
            <Accordion.Item eventKey="3">
              <Accordion.Header>Does it maximize content for interaction?</Accordion.Header>
              <Accordion.Body>
                Yes, the app recommends text length, image/video sizes, and hashtags to achieve maximum reach, likes, comments, and shares.
              </Accordion.Body>
            </Accordion.Item>
  
            <Accordion.Item eventKey="4">
              <Accordion.Header>Can I post from the tool?</Accordion.Header>
              <Accordion.Body>
                Yes, you can schedule posts directly to Facebook for optimal engagement.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
  
          <p>
            Ready to start sharing awesome stuff on Facebook? The Facebook Post & Content Creator Tool gives you everything you need to quickly create professional, high-converting posts in minutes. Maximize your content, inspire fans, and increase your Facebook presence. Get started creating content that gets results today!
          </p>
  
          <div className="d-flex justify-content-center mt-4">
            <Button
              onClick={() => setShowMore(false)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #dc3545",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#dc3545";
              }}
            >
              Hide
            </Button>
          </div>
        </>
      )}
  
      <Trialcards />
      <Related />
      <TestimonialPage />
      <Specialoffer />
      <BackLinkCards />
    </Col>
  </>
  
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Boost Your Rankings Risk-Free —{" "}
          <span style={{ color: "#FC4100" }}>Free for 3 Months</span>, Limited
          Time Only!
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Keyword Magic Tool helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  //   const handleClick = () => {
  //     navigate("/da-pa-checker");
  //   };

  return (
    <div className="mt-5 mb-5">
      <div
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Run a Free Site Audit in Seconds</b>
            </h3>
            <p className="text-center">
              Analyze your website’s SEO health — uncover issues, technical
              errors, and on-page problems holding your rankings back.
            </p>

            <Seoanalyzer />
          </Col>
        </Row>
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Backlink Checker",
    description:
      "Scan your site’s backlink profile and detect missing or harmful links instantly.",
    linkText: "Backlink Checker",
    linkUrl: "/backlink-checker",
    bgColor: "#f4f7fb",
  },
  {
    title: "Top Pages",
    description:
      "Analyze your most linked pages and compare performance with competitors. Discover high-impact SEO opportunities.",
    linkText: "Top Pages",
    linkUrl: "/check-top-linking-domain",
    bgColor: "#dff5ff",
  },
  {
    title: "Link Building Tool",
    description:
      "Identify broken or missing backlinks and transform them into fresh opportunities to build stronger connections.",
    linkText: "Link Building Tool",
    linkUrl: "/link-building-tool",
    bgColor: "#f4f7fb",
  },
  {
    title: "Domain Authority",
    description:
      "Evaluate any website's authority score and SEO potential using over 15 trusted ranking signals and domain metrics.",
    linkText: "DA Checker",
    linkUrl: "/da-pa-checker",
    bgColor: "#d6ffd6",
  },
];
const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            Backlink Optimization Toolkit: Everything You Need
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
const Seoanalyzer = () => {
  const { siteurl } = useContext(GlobalContext);
  const [URL, setURL] = useState(siteurl || "");
  const [submittedURL, setSubmittedURL] = useState(siteurl || "");

  useEffect(() => {
    setURL(siteurl || "");
    setSubmittedURL(siteurl || "");
  }, [siteurl]);

  const handleChange = (event) => {
    setURL(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmittedURL(URL.trim());
  };

  return (
    <div
      className="m-3 mt-4"
      style={{
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <style>
        {`
              .hide-scrollbar::-webkit-scrollbar {
                display: none;
              }
            `}
      </style>

      {/* Input Form - always visible */}
      <form
        onSubmit={handleSubmit}
        className="d-flex align-items-center justify-content-center"
      >
        <div className="form-group mb-0 mx-2" style={{ width: "20rem" }}>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Website URL e.g. https://google.com"
            value={URL}
            onChange={handleChange}
          />
        </div>
        <button
          type="submit"
          className="btn"
          style={{ background: "#441752", color: "#fff" }}
        >
          Inspect
        </button>
      </form>

      {/* Always show results */}
      <div className="mt-4">
        <Seoanalyzeres url={submittedURL} />
      </div>
    </div>
  );
};

const Seoanalyzeres = ({ url }) => {
  const [seoData, setSeoData] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const formatUrl = (url) => {
    if (!/^https?:\/\//i.test(url)) {
      return `https://${url}`;
    }
    return url;
  };
  const { password, username } = basicauth;
  const base64Credentials =
    "aW5mb0BzZW9iaXhAYnVtcHB5QGdvc2VvOmdvc2VvQGJ1bXBweUBzZW9iaXhAaW5mbw==";

  useEffect(() => {
    const fetchData = async () => {
      if (!url) return;

      setLoading(true);
      const formattedUrl = formatUrl(url);
      const trimmedUrl = formattedUrl.trim();

      try {
        const response = await fetch(
          `${BASE_URL_API_TRANXT_UAT_API}/api/OnPage/GetSeoScore`,
          {
            method: "POST",
            headers: {
              Authorization: `Basic ${base64Credentials}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ url: trimmedUrl }),
          }
        );

        const data = await response.json();
        setSeoData(data);
      } catch (error) {
        console.error("Failed to fetch SEO data:", error);
        setSeoData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "200px",
          background: "transparent",
        }}
      >
        <img src={loaderGif} alt="Loading..." style={{ height: "20%" }} />
      </div>
    );
  }

  if (!seoData) return null;

  const pieData = [
    ["Task", "Hours per Day"],
    ["Score", seoData.score],
    ["Remaining", 100 - seoData.score],
  ];

  const pieOptions = {
    backgroundColor: "transparent",
    is3D: true,
    legend: { position: "none" },
    slices: {
      0: { offset: 0, color: "#FFCE56" },
      1: { offset: 0, color: "#C0C0C0" },
    },
  };

  const totalTests = seoData.totalTests;
  const passedTests = seoData.passedTests.length;
  const failedTests = seoData.failedTests.length;
  const warningTests = totalTests - passedTests - failedTests;

  const percentagePassed = (passedTests / totalTests) * 100;
  const percentageFailed = (failedTests / totalTests) * 100;
  const percentageWarning = (warningTests / totalTests) * 100;

  const handleClick = () => {
    navigate("/seo-Inspector");
  };
  return (
    <div>
      <h4 className="text-center">SEO Audit Report</h4>
      <Row>
        <Col md={4}>
          <Card style={{ border: "none", background: "transparent" }}>
            <Chart
              chartType="PieChart"
              data={pieData}
              options={pieOptions}
              width="100%"
              height="350px"
            />
          </Card>
        </Col>
        <Col md={8}>
          <Card
            className="p-2 mt-2"
            style={{ background: "transparent", border: "none" }}
          >
            {/* <Card.Title style={{ color: "black" }}>SEO Test Results</Card.Title> */}

            <ProgressBarSection
              label="Total Tests"
              count={totalTests}
              percent={100}
              variant="info"
            />
            <ProgressBarSection
              label="Passed Tests"
              count={passedTests}
              percent={percentagePassed}
              variant="success"
            />
            <ProgressBarSection
              label="Failed Tests"
              count={failedTests}
              percent={percentageFailed}
              variant="danger"
            />
            <ProgressBarSection
              label="Warning Tests"
              count={warningTests}
              percent={percentageWarning}
              variant="warning"
            />
          </Card>
          <h6 className="text-end m-4" onClick={handleClick}>
            Click to get more details <FaArrowRight />
          </h6>
        </Col>
      </Row>
    </div>
  );
};

const ProgressBarSection = ({ label, count, percent, variant }) => (
  <div className="mb-3">
    <div className="d-flex justify-content-between mb-2">
      <span>{label}</span>
      <span>
        {count} ({Math.round(percent)}%)
      </span>
    </div>
    <ProgressBar now={percent} variant={variant} />
  </div>
);
export default FacebookPostContentCreator;
